<template>
  <div class="effect_box">
    <!-- 分割线 -->
    <div class="cut_off">
      <div class="div_green"></div>
      <div class="div_blue"></div>
      <div class="div_yellow"></div>
    </div>
    <!-- 内容 -->
    <div class="box_content">
      <!-- green -->
      <div class="box_green">
        <div class="box_title">海量網購使用者</div>
        <div class="box_content_box">資訊時代網路使用頻率高，網購人口逐年遞增</div>
        <img class="box_img" src="../../../assets/img/home/icon_box_green.png" alt="">
        <div class="box_more">{{more}}</div>
      </div>
      <!-- blue -->
      <div class="box_blue">
        <div class="box_title">多種付款方式</div>
        <div class="box_content_box">不管是轉帳還是超商付款總有一種適合你</div>
        <img class="box_img" src="../../../assets/img/home/icon_box_blue.png" alt="">
        <div class="box_more">{{more}}</div>
      </div>
      <!-- yellow -->
      <div class="box_yellow">
        <div class="box_title">跨境多幣種支援</div>
        <div class="box_content_box">人民幣、美金、日圓，想賺錢，幣種絕對不是問題</div>
        <img class="box_img" src="../../../assets/img/home/icon_box_yellow.png" alt="">
        <div class="box_more">{{more}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'HomeEffect',
  props: {
  },
  data() {
    return {
      more: "了解更多",
    }
  },
  computed: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .effect_box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-width: 880px;
  }
  /* 分割线 */
  .cut_off {
    display: flex;
    margin-bottom: 30px;
  }
  .cut_off > div {
    flex: 1;
    height: 17px;
  }
  .cut_off .div_green {
    background: #a0e557;
  }
  .cut_off .div_blue {
    background: #5789d6;
  }
  .cut_off .div_yellow {
    background: #f4b12a;
  }
  /* 内容 */
  .box_content {
    display: flex;
  }
  .box_content > div {
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #f2f2f2;
    border-right: 1px solid #f2f2f2;
  }
  .box_content .box_title {
    margin: 35px 0 20px 0;
    font-size: 41px;
    font-weight: bold;
    color: #000000;
  }
  .box_content .box_content_box {
    font-size: 21px;
    padding: 0 6px;
    text-align: center;
    color: #777777;
    margin-bottom: 12px;
  }
  .box_content .box_more {
    cursor:pointer;
    font-size: 11px;
    padding: 12px 20px;
    color: #ffffff;
    background: #000000;
    border-radius: 12px;
    margin-bottom: 20px;
  }




    /*  */
@media screen and (max-width:768px){

  /* 显示/隐藏 */  
  .effect_box {
    display: none;
  }

}
</style>
